import { useURLSearchParam } from './use_url_search_param';

const TRUE_VALUE = 'yes';
const FALSE_VALUE = 'no';

const deserialize = (value: string | undefined): boolean | undefined => {
  if (value === TRUE_VALUE || value === String(true)) return true;
  if (value === FALSE_VALUE || value === String(false)) return false;
  return undefined;
};

const serialize = (value: boolean | undefined): string | undefined => {
  if (value === true) return TRUE_VALUE;
  if (value === false) return FALSE_VALUE;
  return undefined;
};

export const useBooleanURLSearchParam = (name: string, fallback: boolean | undefined = undefined) => {
  const [value, onChange] = useURLSearchParam(name);

  return [
    deserialize(value) ?? fallback,
    (value: boolean | undefined) => {
      onChange(value === fallback ? undefined : serialize(value));
    },
  ] as const;
};
